/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

const ApiService = Shopware.Classes.ApiService;

class DvsnFormBuilderInAppService extends ApiService {
    technicalName = 'dvsnformbuilderinapp';
    extensionName = 'DvsnFormBuilder';
    plans = {
        none: {
            key: 'none',
            name: 'Free',
            value: 1,
            icon: 'regular-gift',
            price: '0 €*'
        },
        lite: {
            key: 'lite',
            name: 'Lite',
            value: 3,
            icon: 'regular-e-scooter',
            price: '8,50 €*'
        },
        basic: {
            key: 'basic',
            name: 'Basic',
            value: 10,
            icon: 'regular-truck',
            price: '16,58 €*'
        },
        pro: {
            key: 'pro',
            name: 'Pro',
            value: null,
            icon: 'regular-rocket',
            price: '33,25 €*'
        }
    };

    constructor(httpClient, loginService, apiEndpoint = '') {
        super(httpClient, loginService, apiEndpoint);
    }

    requestCheckout(plan) {
        Shopware.Store.get('inAppPurchaseCheckout').request({identifier: this.technicalName + plan}, this.extensionName);
    }

    isPlanLimitReached(count) {
        if (this.getMax() === null) {
            return false;
        }

        return count >= this.getMax();
    }

    getMax() {
        if (this.getActivePlan() === null) {
            return this.plans[Object.keys(this.plans)[0]].value;
        }

        return this.plans[this.getActivePlan()].value;
    }

    getPlans() {
        return this.plans;
    }

    getActivePlan() {
        const purchases = Shopware.InAppPurchase.getByExtension(this.extensionName);

        if (!purchases || purchases.length === 0) {
            return null;
        }

        return purchases[0].replace(this.technicalName, '');
    }
}

export default DvsnFormBuilderInAppService;
